// @flow

import Env from './environment';
const AppEnv = process.env.NODE_ENV;
const AppUrl = window.location.origin;
const ScriptPath = '/content/download/';
const TryItNowPath = '/content/api/';
const XMLPath = '/content/xml/';

const AppConfig = {
    XmlContentPath:
        AppEnv === Env.Production
            ? `${AppUrl}${XMLPath}`
            : 'http://localhost:3000/content/xml/',
    TryApiPath:
        AppEnv === Env.Production
            ? `${AppUrl}${TryItNowPath}`
            : 'http://localhost:3000/content/api/',
    Scripts:
        AppEnv === Env.Production
            ? `${AppUrl}${ScriptPath}`
            : 'http://localhost:3000/content/download/',
    ApiBaseURL: 
        AppUrl === 'https://developer.sureprep.com'
            ? 'api.sureprep.com'
            : (AppUrl === 'https://developer-dev.sureprep.com' || AppUrl === 'http://localhost:3000')
                ? 'apidev.sureprep.com'
                : 'apistage.sureprep.com',
    FileRoomActionMethodURL: 'https://iscrumdev.sureprep.com/sso/CreateSessionForDevPortal',
    CookieExpiryInMinutes: 43200,
};

export default AppConfig;
